/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AdditionalServiceGroupByWareIdRespVo
 */
export interface AdditionalServiceGroupByWareIdRespVo {
    /**
     * 服务组id
     * @type {number}
     * @memberof AdditionalServiceGroupByWareIdRespVo
     */
    id?: number;
    /**
     * 服务组名称
     * @type {string}
     * @memberof AdditionalServiceGroupByWareIdRespVo
     */
    name?: string;
    /**
     * 服务组名(中)
     * @type {string}
     * @memberof AdditionalServiceGroupByWareIdRespVo
     */
    nameCn?: string;
    /**
     * 服务组编码
     * @type {string}
     * @memberof AdditionalServiceGroupByWareIdRespVo
     */
    code?: string;
    /**
     * 账单类型编号
     * @type {number}
     * @memberof AdditionalServiceGroupByWareIdRespVo
     */
    billType?: number;
    /**
     * checkbox 是否选中 1选中 0不选中
     * @type {number}
     * @memberof AdditionalServiceGroupByWareIdRespVo
     */
    selected?: number;
}

/**
 * Check if a given object implements the AdditionalServiceGroupByWareIdRespVo interface.
 */
export function instanceOfAdditionalServiceGroupByWareIdRespVo(value: object): value is AdditionalServiceGroupByWareIdRespVo {
    return true;
}

export function AdditionalServiceGroupByWareIdRespVoFromJSON(json: any): AdditionalServiceGroupByWareIdRespVo {
    return AdditionalServiceGroupByWareIdRespVoFromJSONTyped(json, false);
}

export function AdditionalServiceGroupByWareIdRespVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdditionalServiceGroupByWareIdRespVo {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'nameCn': json['nameCn'] == null ? undefined : json['nameCn'],
        'code': json['code'] == null ? undefined : json['code'],
        'billType': json['billType'] == null ? undefined : json['billType'],
        'selected': json['selected'] == null ? undefined : json['selected'],
    };
}

export function AdditionalServiceGroupByWareIdRespVoToJSON(json: any): AdditionalServiceGroupByWareIdRespVo {
    return AdditionalServiceGroupByWareIdRespVoToJSONTyped(json, false);
}

export function AdditionalServiceGroupByWareIdRespVoToJSONTyped(value?: AdditionalServiceGroupByWareIdRespVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'nameCn': value['nameCn'],
        'code': value['code'],
        'billType': value['billType'],
        'selected': value['selected'],
    };
}

